import { render } from "./FormStep.vue?vue&type=template&id=effbb1e8"
import script from "./FormStep.vue?vue&type=script&lang=js"
export * from "./FormStep.vue?vue&type=script&lang=js"

import "./FormStep.vue?vue&type=style&index=0&id=effbb1e8&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__